let language = null;

const supportedCultures = ["ru", "en"];
export default {
  getLanguage: () => {
    if (!language && window.getSupportedCulture) {
      language = window.getSupportedCulture(supportedCultures);
    }
    return language || 'ru';
  }
};
